import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { contentGlobalSuccess } from '../../../../content.error';
import { fb } from '../../../../../shared/shared.global-service';
import { Validators } from '@angular/forms';
import { FolderDataShareObject } from '@libs/types/src/services/object-type/folder/folder-data-share.object';
import { PersonShareDataWithServiceStore } from '../person-share-data-with-service.store';
import { dateify } from '../../../../../shared/helpers/date.helper';
import { isInvalid } from '../../../../../shared/helpers/validate';
import { FolderDataShareCreateInput } from '@libs/types/src/services/input-type/folder/folder-data-share.create-input';
import { FolderDataShareUpdateInput } from '@libs/types/src/services/input-type/folder/folder-data-share.update-input';
import { BaseDialogComponent } from '../../../../../../components/kit/base-dialog/base-dialog.component';
import { FolderDashboardPageStore } from '../../../../pages/person/folder-dashboard-page/folder-dashboard-page.store';
import { DateInputComponent } from '../../../../../../components/kit/input/date-input/date-input.component';
import { SelectInputComponent } from '../../../../../../components/kit/input/select-input/select-input.component';
import { TextInputComponent } from '../../../../../../components/kit/input/text-input/text-input.component';

@Component({
    selector: 'app-person-share-data-dialog',
    templateUrl: './person-share-data-dialog.component.html',
    providers: [PersonShareDataWithServiceStore, FolderDashboardPageStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        DateInputComponent,
        SelectInputComponent,
        TextInputComponent,
    ],
})
export class PersonShareDataDialogComponent extends BaseDialogComponent implements OnInit {
    protected readonly store = inject(PersonShareDataWithServiceStore);
    protected readonly dashboardStore = inject(FolderDashboardPageStore);

    protected form = fb.group({
        dateFrom: fb.control<Date | null>(null, [Validators.required]),
        dateTo: fb.control<Date | null>(null),
        note: fb.control(''),
        serviceId: fb.control<number | null>(null, [Validators.required]),
    });

    share: FolderDataShareObject | null = null;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.share = this.dialogConfig.data.share;
        if (this.share) {
            this.form.patchValue({
                ...this.share,
                dateFrom: new Date(this.share.dateFrom),
                dateTo: dateify(this.share.dateTo),
            });
        }
    }

    override async save() {
        const folderId = this.store.folderId();
        if (isInvalid(this.form) || !folderId) return;

        if (!this.share) {
            const data = {
                ...this.form.value,
                folderId: folderId,
                dateFrom: this.form.value.dateFrom!.toISOString(),
                dateTo: this.form.value.dateTo?.toISOString(),
            } as FolderDataShareCreateInput;
            await this.store.api.createFolderDataShare(data);
            contentGlobalSuccess.next('common.created');
        } else {
            const data = {
                id: this.share.id,
                ...this.form.value,
                dateFrom: this.form.value.dateFrom!.toISOString(),
                dateTo: this.form.value.dateTo?.toISOString(),
            } as FolderDataShareUpdateInput;
            await this.store.api.updateFolderDataShare(data);
            contentGlobalSuccess.next('common.updated');
        }
        this.dialogRef.close();
    }
}
